import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import {
    FormSelectDropdownContainer,
    InputContainer,
    StyledIconInfo,
    InputWrapper,
    CurrencySymbol,
    StyledInput,
    FormLabel,
    FormSelect,
    FormButton,
    RunModalOverlay,
    ModalContainer,
    ModalCloseButton,
    SpinningIcon,
    DescriptionContainer,
    DescriptionTopLine,
    DescriptionP,
    InfoLabel,
} from './RunModalElements';
import { run_trader, get_jobs } from '../LaytraderLibrary/LaytraderRequest';
import { Description } from '@mui/icons-material';

const RunModal = ({ isOpen, onClose, models, selectedAccount, token, accounts, setAccounts, setDemoState, isAdmin }) => {
    const [model, setModel] = useState(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [minimum, setMinimum] = useState(0.0);
    const [showDescription, setShowDescription] = useState(false);


    const labelRef = useRef();

    if (!isOpen) return null;

    const Tooltip = ({ targetRef, tipTitle = "", message, addTop = 0, addRight = 0, tuneTop = false, tuneRight = false }) => {
        const [coords, setCoords] = useState({ top: 0, left: 0 });

        useEffect(() => {
            if (targetRef.current) {
                const rect = targetRef.current.getBoundingClientRect();
                setCoords({ top: rect.top + window.scrollY + addTop, right: window.innerWidth - rect.right + addRight });
            }
        }, [targetRef]);
        const top = `${coords.top}px`
        const right = `${coords.right}px`


        const triangleTop = coords.top + 5;
        const triangleRight = coords.right - 10;
        const topT = `${triangleTop}px`
        const rightT = `${triangleRight}px`

        const tuneTopVal = `${triangleTop + 50}px`
        const tuneRightVal = `${triangleRight}px`
        return ReactDOM.createPortal(
            <>
                <DescriptionContainer top={top} right={right} tuneTop={tuneTop} tuneTopVal={tuneTopVal} tuneRight={tuneRight} tuneRightVal={tuneRightVal} >
                    <DescriptionTopLine>Trade Stop</DescriptionTopLine>
                    <DescriptionP>A value greater than or equal to zero that represents the lowest value that Lay Trader is allowed to continue trading. For Example: If Trade Stop is set to $10,000 Lay Trader will cancel future trades if the value of the watchlist positions plus the cash on hand is below $10,000. The default value of $0.00 removes this constraint.</DescriptionP>
                </DescriptionContainer>
            </>,
            document.body
        );
    };

    const handleChange = (e) => {
        const value = e.target.value;

        // RegEx: Matches numbers with up to two optional decimal places (e.g., 10, 10.5, 10.55)
        const validCurrencyRegex = /^\d*\.?\d{0,2}$/;

        if (validCurrencyRegex.test(value)) {
            setMinimum(value);
        }
    };


    const runTrader = async (e) => {
        e.preventDefault();
        setLoading(true);
        e.preventDefault();
        const submitRun = async () => {
            const response = await run_trader(token, model, selectedAccount, minimum); //todo: CHANGE THIS TO MINIMUM 
            const target_account = accounts.accounts.find(obj => obj.account_id === selectedAccount);
            target_account.tasks = response.tasks
            const updated_accounts = accounts.accounts.map(obj => obj.account_id === selectedAccount ? target_account : obj);//if we want default behavior to turn off the other account visabilty  change this to {...obj, visible: false}
            setDemoState(7);
            onClose(e);
            setAccounts(prev => ({ ...prev, accounts: updated_accounts.sort((a, b) => a.account_id - b.account_id) }));
            setLoading(false);
        };
        submitRun();

    };

    return (
        <RunModalOverlay>
            <ModalContainer>
                <InputContainer>
                    <InfoLabel ref={labelRef} type="button" onClick={() => setShowDescription(!showDescription)} onMouseEnter={() => setShowDescription(true)} onMouseLeave={() => setShowDescription(false)}>Trade Stop:</InfoLabel>
                    <InputWrapper>
                        <CurrencySymbol>$</CurrencySymbol>
                        <StyledInput
                            id="donation-amount"
                            type="text"
                            inputMode="decimal"
                            placeholder="0.00"
                            value={minimum}
                            onChange={handleChange}
                        />
                    </InputWrapper>
                </InputContainer>
                {showDescription && <Tooltip tipTitle={"Account Modification"} targetRef={labelRef} addTop={5} addRight={-200} tuneTop={true} tuneRight={true} message={"Add your accounts"} />}
                {isAdmin && <FormSelectDropdownContainer>
                    <FormLabel htmlFor="model">Select Model:</FormLabel>
                    {<FormSelect id="model_select" onChange={(e) => setModel(e.target.value)}>
                        {/* <option value="" disabled selected hidden></option> */}
                        {models.map((m) => (
                            <option>
                                {m}
                            </option>
                        ))}
                    </FormSelect>}
                </FormSelectDropdownContainer>}
                <FormButton onClick={(e) => runTrader(e)}>Run Trader</FormButton>
                {loading === true &&
                    <SpinningIcon />
                }
                <text>{error}</text>
                <ModalCloseButton onClick={(e) => onClose(e)}>Cancel</ModalCloseButton>

            </ModalContainer>
        </RunModalOverlay>
    );
};


export default RunModal;
